import React, { useState, useEffect } from 'react'
import { useTranslation } from 'i18n'

import { objectsEqual } from 'utils/objects'
import XText from 'v2/components/XText'
import { XTEXT_SIZE, XTEXT_TYPE } from 'v2/styles/constants'
import XColors from '../../styles/colors'
import style from './style.module.scss'

interface Props {
    children?: React.ReactNode
    forElementId?: string
    id: string
}

const XInputError: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation(window.LANG_NS)

    const { children, forElementId } = props
    const [forElement, setForElement] = useState<HTMLElement | null>(null)
    const [coords, setCoords] = useState<{
        left: number
        right: number
        width: number
        top: number
    } | null>(null)

    const ele = document.getElementById(forElementId)
    const widerValueForErrorsCompletelyHacky = 8

    const onResize = () => {
        setCoords({
            left: ele?.offsetLeft,
            right: ele?.offsetLeft + ele?.offsetWidth,
            width: ele?.offsetWidth + widerValueForErrorsCompletelyHacky,
            top: ele?.offsetTop + ele?.offsetHeight,
        })
    }

    useEffect(() => {
        const c = {
            left: ele?.offsetLeft,
            right: ele?.offsetLeft + ele?.offsetWidth,
            width: ele?.offsetWidth + widerValueForErrorsCompletelyHacky,
            top: ele?.offsetTop + ele?.offsetHeight,
        }
        // @ts-ignore
        if (!objectsEqual(coords, c)) {
            onResize()
        }
    })

    useEffect(() => {
        if (forElementId) {
            setForElement(ele)
            window.addEventListener('resize', onResize)
            return () => {
                window.removeEventListener('resize', onResize)
            }
        }
    }, [forElementId, t, props.children])

    if (!forElement) return null

    return (
        coords && (
            <div className={style.xError} id={props.id} style={{ ...coords }}>
                <XText size={XTEXT_SIZE.MEDIUM} type={XTEXT_TYPE.ERROR} color={XColors.secondaryRed}>
                    {children}
                </XText>
            </div>
        )
    )
}
export default XInputError
